import React from 'react';
import { Table } from 'reactstrap';
import { InfoToolTip } from './InfoToolTip';
import { T } from '../traks';
import {dataPlaceholder, formatWithSeparators} from '../misc'

const getLink = () => {
  if (IS_AKTIEDYSTEN_DK) {
    return "https://inspiration.aktiedysten.dk/vaekst-din-viden-regnskab/";
  } else if (IS_AKTIEKAMPEN_SE) {
    return "https://aktiekampen.se";
  } else if (IS_INVESTSPIEL_DE) {
    return "https://investspiel.de";
  } else if (IS_TRADERR_COM) {
    return "https://traderr.com";
  } else {
    return "#";  
  }
}


export const FinancialData = (props) => {
const link = getLink();

const incomeStatementData = props.incomeStatement;
const balanceSheetData = props.balanceSheet;
const cashFlowData = props.cashFlow;

const getDataForYear = (dataSet, year, field) => {
    if (!dataSet) {
        return dataPlaceholder();
    }

    const data = dataSet[year] ? dataSet[year][field] : null;

    return typeof data === 'number' ? formatWithSeparators(data) : dataPlaceholder();
};

  return (
    <div className="py-4 px-3 mx-2 ad_financial_info">
      <div className='mt-3 ad_financial_info_header'>
       <h4><T>Financial Statements</T></h4>
      </div>
      
      <div className='d-flex mt-4 ad_financial_info_heading'>
        <h5 className='mb-0'><T>Annual Report</T></h5>
        <td>
          <InfoToolTip 
            title={<T>Annual Report</T>} 
            tooltipText={<T>
              <p><strong>What is it?</strong> The annual report shows how the company has performed financially over the year. Think of it as their report card for finances – here you can see if they’ve aced it or just barely scraped by.</p>
              <p><strong>Why is it important?</strong> It gives you a clear picture of the company’s financial performance – how much money they’ve made, what they’ve spent, and what they have left.</p>
            </T>} 
            link={link}
          />
        </td>
      </div>
      <div className="table-responsive-horizontal">
      <Table borderless size='sm' className='ad_financial_info_table'>
        <thead>
          <tr>
            <th><T>Year</T></th>
            <th>2023</th>
            <th>2022</th>
            <th>2021</th>
            <th>2020</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><T>Revenue</T></td>
            <td>{getDataForYear(incomeStatementData, '2023', 'Revenue')}</td>
            <td>{getDataForYear(incomeStatementData, '2022', 'Revenue')}</td>
            <td>{getDataForYear(incomeStatementData, '2021', 'Revenue')}</td>
            <td>{getDataForYear(incomeStatementData, '2020', 'Revenue')}</td>
            <td>
              <InfoToolTip 
                title={<T>Revenue</T>} 
                tooltipText={<T>
                  <p><strong>What is it?</strong> It’s the money rolling in every time the company sells something. It’s the company’s total "income" from selling goods and services.</p>
                  <p><strong>Why is it important?</strong> Revenue shows how good the company is at getting its products out the door (sold) and into customers' hands. It’s like keeping track of how many goals your favorite team scores – and you definitely want a lot of goals!</p>
                </T>} 
                link={link} 
              />
            </td>
          </tr>
          <tr>
            <td><T>Costs</T></td>
            <td>{getDataForYear(incomeStatementData, '2023', 'Costs')}</td>
            <td>{getDataForYear(incomeStatementData, '2022', 'Costs')}</td>
            <td>{getDataForYear(incomeStatementData, '2021', 'Costs')}</td>
            <td>{getDataForYear(incomeStatementData, '2020', 'Costs')}</td>
            <td>
              <InfoToolTip 
                title={<T>Operating Costs</T>} 
                tooltipText={<T>
                  <p><strong>What is it?</strong> It's the variable costs a company incurs in the production and sale of its goods - like raw materials and production costs. Think of it like shopping for your lemonade stand: what ingredients do you need to make something your neighbours will buy?</p>
                  <p><strong>Why is this important?</strong> It's all about keeping costs under control! If your business spends too much here, it can quickly eat into your profits. Just like with the lemonade stand: If you buy expensive ingredients but sell too cheap, you end up losing money. A business needs to be smart and balance their expenses so they have the best opportunities to make a good profit!’</p>
                </T>} 
                link={link} 
              />
            </td>
          </tr>
          <tr>
            <td><T>Gross Profit</T></td>
            <td>{getDataForYear(incomeStatementData, '2023', 'GrossProfit')}</td>
            <td>{getDataForYear(incomeStatementData, '2022', 'GrossProfit')}</td>
            <td>{getDataForYear(incomeStatementData, '2021', 'GrossProfit')}</td>
            <td>{getDataForYear(incomeStatementData, '2020', 'GrossProfit')}</td>
            <td>
              <InfoToolTip 
                title={<T>Gross Profit</T>} 
                tooltipText={<T>
                  <p><strong>What is it?</strong> It's the difference between revenue and the cost of products sold.</p>
                  <p><strong>Why is it important?</strong> It shows how much the company earns after they have paid to make or purchase their products. For example, when you've bought your new trainers - the more you have left, the better!</p>
                </T>} 
                link={link} 
              />
            </td>
          </tr>
          <tr>
            <td><T>Operating Costs</T></td>
            <td>{getDataForYear(incomeStatementData, '2023', 'OperatingCosts')}</td>
            <td>{getDataForYear(incomeStatementData, '2022', 'OperatingCosts')}</td>
            <td>{getDataForYear(incomeStatementData, '2021', 'OperatingCosts')}</td>
            <td>{getDataForYear(incomeStatementData, '2020', 'OperatingCosts')}</td>
            <td>
              <InfoToolTip 
                title={<T>Operating Expenses</T>} 
                tooltipText={<T>
                  <p><strong>What is it?</strong> It's all the money the company spends to keep the store running. Think of things like employee salaries and rent. All the things that keep the business running day after day.</p>
                  <p><strong>Why is this important?</strong> It tells you how effective the business is at managing its expenses. If they can keep operating costs down, they can keep more money and make more money. ’</p>
                </T>} 
                link={link} 
              />
            </td>
          </tr>
          <tr>
            <td><T>Operating Profit</T></td>
            <td>{getDataForYear(incomeStatementData, '2023', 'OperatingProfit')}</td>
            <td>{getDataForYear(incomeStatementData, '2022', 'OperatingProfit')}</td>
            <td>{getDataForYear(incomeStatementData, '2021', 'OperatingProfit')}</td>
            <td>{getDataForYear(incomeStatementData, '2020', 'OperatingProfit')}</td>
            <td>
              <InfoToolTip 
                title={<T>Operating profit (EBIT)</T>} 
                tooltipText={<T>
                  <p><strong>What is it?</strong> It's the profit that remains after all operating costs have been deducted from revenue.</p>
                  <p><strong>Why is it important?</strong> It shows whether the company is actually making money on what they do every day. In other words, how good their core business is at generating profit. If the operating profit is good, then the business is going in the right direction.</p>
                </T>} 
                link={link} 
              />
            </td>
          </tr>
          <tr>
            <td><T>Profit Before Tax</T></td>
            <td>{getDataForYear(incomeStatementData, '2023', 'ProfitBeforeTax')}</td>
            <td>{getDataForYear(incomeStatementData, '2022', 'ProfitBeforeTax')}</td>
            <td>{getDataForYear(incomeStatementData, '2021', 'ProfitBeforeTax')}</td>
            <td>{getDataForYear(incomeStatementData, '2020', 'ProfitBeforeTax')}</td>
            <td>
              <InfoToolTip 
                title={<T>Profit before taxes (IBT)</T>} 
                tooltipText={<T>
                  <p><strong>What is it?</strong> It's the profit after deducting financial costs such as interest. In other words, what does the company earn from its core business. It's the amount of profit the company makes before they have to cough up money to the taxman.</p>
                  <p><strong>Why is this important?</strong> It shows how much the company has actually earned before tax comes into play. It's an important indicator of how well the company is doing before they have to pay their ‘joint bill’ to the government.’</p>
                </T>} 
                link={link} 
              />
            </td>
          </tr>
          <tr>
            <td><T>Profit After Tax</T></td>
            <td>{getDataForYear(incomeStatementData, '2023', 'ProfitAfterTax')}</td>
            <td>{getDataForYear(incomeStatementData, '2022', 'ProfitAfterTax')}</td>
            <td>{getDataForYear(incomeStatementData, '2021', 'ProfitAfterTax')}</td>
            <td>{getDataForYear(incomeStatementData, '2020', 'ProfitAfterTax')}</td>
            <td>
              <InfoToolTip 
                title={<T>Net Income</T>} 
                tooltipText={<T>
                  <p><strong>What is it?</strong> It's the amount the company has left after all bills are paid - both costs and taxes. It's the final profit!</p>
                  <p><strong>Why is it important?</strong> It shows how much the company actually earns for its owners, the shareholders. It's like seeing how much you have left after a shopping trip when both the goods and VAT are paid - that's the money you can count on!’</p>
                </T>} 
                link={link} 
              />
            </td>
          </tr>
        </tbody>
      </Table>
      </div>
      
      <div className='d-flex mt-4 ad_financial_info_heading'>
        <h5 className="mb-0"><T>Balance sheet</T></h5>
        <td>
          <InfoToolTip 
            title={<T>Balance sheet</T>} 
            tooltipText={<T>
              <p><strong>What is it?</strong> The balance sheet shows what the company owns (assets) and what they owe (debts), as well as what they have left as equity. It's like checking your bank account: how much do you have and how much do you owe?</p>
              <p><strong>Why is this important?</strong> It gives you a quick idea of how solid the company is financially - how much value they have and how much they owe. As a shareholder, you want to see that the company has more value than debt!’</p>
            </T>} 
            link={link} 
          />
        </td>
      </div>
      <div className="table-responsive-horizontal">
      <Table borderless size='sm' className='ad_financial_info_table'>
        <thead>
          <tr>
            <th><T>Year</T></th>
            <th>2023</th>
            <th>2022</th>
            <th>2021</th>
            <th>2020</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><T>Fixed Assets</T></td>
            <td>{getDataForYear(balanceSheetData, '2023', 'FixedAssets')}</td>
            <td>{getDataForYear(balanceSheetData, '2022', 'FixedAssets')}</td>
            <td>{getDataForYear(balanceSheetData, '2021', 'FixedAssets')}</td>
            <td>{getDataForYear(balanceSheetData, '2020', 'FixedAssets')}</td>
            <td>
              <InfoToolTip 
                title={<T>Fixed Assets</T>} 
                tooltipText={<T>
                  <p><strong>What is it?</strong> Think of it as the company's expensive gadgets and tools that don't wear out after a day or two. For example, buildings, machinery or patents.</p>
                  <p><strong>Why is it important?</strong> Fixed assets show how much the company has invested in long-term things that can help make money in the future. For you as a shareholder, it's a sign of how solid the company is and whether it's well equipped to succeed in the long run. ’</p>
                </T>} 
                link={link} 
              />
            </td>
          </tr>
          <tr>
            <td><T>Current Assets</T></td>
            <td>{getDataForYear(balanceSheetData, '2023', 'CurrentAssets')}</td>
            <td>{getDataForYear(balanceSheetData, '2022', 'CurrentAssets')}</td>
            <td>{getDataForYear(balanceSheetData, '2021', 'CurrentAssets')}</td>
            <td>{getDataForYear(balanceSheetData, '2020', 'CurrentAssets')}</td>
            <td>
              <InfoToolTip 
                title={<T>Current assets</T>} 
                tooltipText={<T>
                  <p><strong>What is it?</strong> It's the things the company has that can turn into money within a year. It could be inventory, money in the bank or money still owed by customers. Think of it as the company's ‘fast money’</p>
                  <p><strong>Why is this important?</strong> It shows how quickly the company can raise money to pay bills and keep the wheels turning. As a shareholder, it gives you an idea of how well the company is doing in the short term - whether they're on top of cash or risk running out before the end of the year.’</p>
                </T>} 
                link={link} 
              />
            </td>
          </tr>
          <tr>
            <td><T>Inventory</T></td>
            <td>{getDataForYear(balanceSheetData, '2023', 'Inventory')}</td>
            <td>{getDataForYear(balanceSheetData, '2022', 'Inventory')}</td>
            <td>{getDataForYear(balanceSheetData, '2021', 'Inventory')}</td>
            <td>{getDataForYear(balanceSheetData, '2020', 'Inventory')}</td>
            <td>
              <InfoToolTip 
                title={<T>Inventory</T>} 
                tooltipText={<T>
                  <p><strong>What is it?</strong> It's the products that are waiting to be sold - like trainers on the shelf or pizzas that haven't been eaten yet. In other words, it's the company's ‘stock of goodies’ that hasn't gone out to customers yet.</p>
                  <p><strong>Why is this important?</strong> It shows how much money the company has tied up in things that have not yet been sold. As a shareholder, you want to know if they have too much lying around gathering dust, because it can be a bad deal if the goods don't sell fast enough. It's like having too much food in the fridge - you want to eat it before it gets boring.’</p>
                </T>} 
                link={link} 
              />
            </td>
          </tr>
          <tr>
            <td><T>Equity</T></td>
            <td>{getDataForYear(balanceSheetData, '2023', 'Equity')}</td>
            <td>{getDataForYear(balanceSheetData, '2022', 'Equity')}</td>
            <td>{getDataForYear(balanceSheetData, '2021', 'Equity')}</td>
            <td>{getDataForYear(balanceSheetData, '2020', 'Equity')}</td>
            <td>
              <InfoToolTip 
                title={<T>Total Equity</T>} 
                tooltipText={<T>
                  <p><strong>What is it?</strong> It's the portion of the company's assets owned by the shareholders - that's you and all the other investors - after all the debt has been paid. Think of it as the company's ‘piggy bank’ - what's left if they sold everything, paid off their loans and still had something left.</p>
                  <p><strong>Why is it important?</strong> Equity represents the value that shareholders own in the company. When you, as a shareholder, own shares, you own a portion of that equity. Therefore, it is a direct reflection of your investment in the company.
                  High equity means that the company has more assets than debt, which is a good sign of financial stability. A company with plenty of equity can better handle bad times without having to borrow money. So it's a bit like having solid savings - it gives you peace of mind in case of unexpected bills.’</p>
                </T>} 
                link={link} 
              />
            </td>
          </tr>
          <tr>
            <td><T>Long-term Debt</T></td>
            <td>{getDataForYear(balanceSheetData, '2023', 'LongTermDebt')}</td>
            <td>{getDataForYear(balanceSheetData, '2022', 'LongTermDebt')}</td>
            <td>{getDataForYear(balanceSheetData, '2021', 'LongTermDebt')}</td>
            <td>{getDataForYear(balanceSheetData, '2020', 'LongTermDebt')}</td>
            <td>
              <InfoToolTip 
                title={<T>Long-Term Debt</T>} 
                tooltipText={<T>
                  <p><strong>What is it?</strong> It's the money the company has borrowed but doesn't have to pay back right away - only after a year or more.</p>
                  <p><strong>Why is it important?</strong> It shows how much debt the company has hanging over it in the long term. As a shareholder, it's important to know how much they've borrowed because it can affect how quickly the company can grow or weather difficult times. It's like having a student loan - how long and how will you pay it back?’</p>
                </T>} 
                link={link} 
              />
            </td>
          </tr>
          <tr>
            <td><T>Short-term Debt</T></td>
            <td>{getDataForYear(balanceSheetData, '2023', 'ShortTermDebt')}</td>
            <td>{getDataForYear(balanceSheetData, '2022', 'ShortTermDebt')}</td>
            <td>{getDataForYear(balanceSheetData, '2021', 'ShortTermDebt')}</td>
            <td>{getDataForYear(balanceSheetData, '2020', 'ShortTermDebt')}</td>
            <td>
              <InfoToolTip 
                title={<T>Risk Value</T>} 
                tooltipText={<T>Expresses the stock's price sensitivity relative to the overall market.</T>} 
                link={link} 
              />
            </td>
          </tr>
        </tbody>
      </Table>
      </div>
      
      <div  className='d-flex mt-4 ad_financial_info_heading'>
        <h5 className="mb-0"><T>Cashflow</T></h5>
        <td>
          <InfoToolTip 
            title={<T>Cashflow</T>} 
            tooltipText={<T>
              <p><strong>What is it?</strong> It shows how much money is coming in and going out. It's like keeping an eye on your own budget: what comes in from salaries and what goes out to bills?</p>
              <p><strong>Why is it important?</strong> A healthy cash flow means that the company is in control of its money and can pay the bills. As a shareholder, you want the money to flow inwards and not outwards, so there's enough to grow the business.</p>
            </T>} 
            link={link} 
          />
        </td>
      </div>
      <div className="table-responsive-horizontal">
      <Table borderless size='sm' className='ad_financial_info_table'>
        <thead>
          <tr>
            <th><T>Year</T></th>
            <th>2023</th>
            <th>2022</th>
            <th>2021</th>
            <th>2020</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><T>Cash Flow from Operations</T></td>
            <td>{getDataForYear(cashFlowData, '2023', 'OperatingCashFlow')}</td>
            <td>{getDataForYear(cashFlowData, '2022', 'OperatingCashFlow')}</td>
            <td>{getDataForYear(cashFlowData, '2021', 'OperatingCashFlow')}</td>
            <td>{getDataForYear(cashFlowData, '2020', 'OperatingCashFlow')}</td>
            <td>
              <InfoToolTip 
                title={<T>Operating Cash Flow</T>} 
                tooltipText={<T>
                  <p><strong>What is it?</strong> It's the money the company earns or spends on its daily activities, like selling products and paying bills.</p>
                  <p><strong>Why is it important?</strong> It shows whether the company is good at generating profits from its core business. As a shareholder, you want to see that the company has a healthy cash flow as it indicates stability - it gives you peace of mind.</p>
                </T>} 
                link={link} 
              />
            </td>
          </tr>
          <tr>
            <td><T>Cash Flow from Investments</T></td>
            <td>{getDataForYear(cashFlowData, '2023', 'InvestingCashFlow')}</td>
            <td>{getDataForYear(cashFlowData, '2022', 'InvestingCashFlow')}</td>
            <td>{getDataForYear(cashFlowData, '2021', 'InvestingCashFlow')}</td>
            <td>{getDataForYear(cashFlowData, '2020', 'InvestingCashFlow')}</td>
            <td>
              <InfoToolTip 
                title={<T>Investing Cash Flow</T>} 
                tooltipText={<T>
                  <p><strong>What is it?</strong> It's the money the company spends or earns on investments, such as buying new machines or selling assets.</p>
                  <p><strong>Why is it important?</strong> It shows whether the company is investing in future growth or selling assets to raise money. As a shareholder, you can see if the company is actively growing. Like a PC, there are upgrades coming all the time, but are you investing in making it perform better?</p>
                </T>} 
                link={link} 
              />
            </td>
          </tr>
          <tr>
            <td><T>Cash Flow from Financing</T></td>
            <td>{getDataForYear(cashFlowData, '2023', 'FinancingCashFlow')}</td>
            <td>{getDataForYear(cashFlowData, '2022', 'FinancingCashFlow')}</td>
            <td>{getDataForYear(cashFlowData, '2021', 'FinancingCashFlow')}</td>
            <td>{getDataForYear(cashFlowData, '2020', 'FinancingCashFlow')}</td>
            <td>
              <InfoToolTip 
                title={<T>Financing Cash Flow</T>} 
                tooltipText={<T>
                  <p><strong>What is it?</strong> It's the money the company receives or pays back through loans or by issuing shares.</p>
                  <p><strong>Why is it important?</strong> It shows how the company finances its activities, either through loans or by raising new money from investors. As a shareholder, it's important to know if the company is taking many loans or diluting the value of your shares by issuing more. Borrowing from a friend or selling off their stuff to get money.</p>
                </T>} 
                link={link} 
              />
            </td>
          </tr>
        </tbody>
      </Table>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/c/FinancialData.js